/* ============================================================================
   Raw Elements — zentrale Motion v3 (TubeBridge 2026-08-06)
   Baut auf dem in theme.liquid geladenen GSAP 3.12.5 + ScrollTrigger auf.
   Ausbau von v2 (Kunde liebt die Motion, will MEHR + Feinschliff):
   - Prozess-Puls sauber von Nummer zu Nummer (ueber den Bildern), praesenter,
     mit Blatt-Motiv im Leucht-Punkt.
   - Hero-USP-Rotator mit mehr Punkten, JS-gesteuert.
   - Testimonials: Sterne funkeln sequenziell.
   - Durchgestrichene Preise: Rabatt-Linie zeichnet sich, neuer Preis poppt.
   - PDP-Schrittbloecke (re-prozess 4er + re-zubereitung) bekommen dieselbe
     Nummern-Glow-/Linien-Motion wie die Startseiten-Timeline.
   Nur transform/opacity; Glows dekorativ. Vollstaendig
   prefers-reduced-motion-sicher: bei reduce passiert (bis auf statischen
   USP-Fallback) NICHTS, Inhalte bleiben im sichtbaren Endzustand.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMq =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = reduceMq && reduceMq.matches;

  var LEAF_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M12 21V11"/>' +
    '<path d="M12 11C9.8 8.8 9.8 5.4 12 3c2.2 2.4 2.2 5.8 0 8Z"/>' +
    '<path d="M12 13C9.8 11.7 6 12.3 3.8 9.2 6.2 6.7 10.4 8 12 13Z"/>' +
    '<path d="M12 13c2.2-1.3 6-0.7 8.2-3.8C17.8 6.7 13.6 8 12 13Z"/></svg>';

  /* --- Hero-USP-Rotator: laeuft IMMER (auch reduce -> statischer 1. Punkt) - */
  function heroRotator() {
    var content = document.querySelector('.rehero-content');
    if (!content || content.querySelector('.re-hero-rotator')) return;

    var words = [
      'Bio', 'Ohne Zuckerzusatz', 'Ehrlich',
      'Ceremonial Grade', 'Laborgeprüft', 'Vegan'
    ];
    var check =
      '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4 4 10-11" ' +
      'stroke="currentColor" stroke-width="2.6" stroke-linecap="round" ' +
      'stroke-linejoin="round"/></svg>';
    var stage = '';
    words.forEach(function (w, i) {
      stage += '<b class="' + (i === 0 ? 'is-on' : '') + '">' + w + '</b>';
    });

    var p = document.createElement('p');
    p.className = 're-hero-rotator';
    p.setAttribute('aria-hidden', 'true');
    p.innerHTML =
      '<span class="re-hero-rot__i">' + check + '</span>' +
      '<span class="re-hero-rot__stage">' + stage + '</span>';

    var actions = content.querySelector('.rehero-actions');
    if (actions && actions.parentNode)
      actions.parentNode.insertBefore(p, actions.nextSibling);
    else content.appendChild(p);

    if (reduce) return; // statischer erster Punkt, kein Wechsel

    var bs = p.querySelectorAll('.re-hero-rot__stage b');
    var idx = 0;
    setInterval(function () {
      bs[idx].classList.remove('is-on');
      idx = (idx + 1) % bs.length;
      bs[idx].classList.add('is-on');
    }, 2650);
  }

  /* --- Nummern-Fluss (Prozess-Timeline + PDP-Schrittbloecke) --------------- */
  function buildStepFlow(sec, opts) {
    var grid = sec.querySelector(opts.gridSel);
    var nums = gsap.utils.toArray(sec.querySelectorAll(opts.numSel));
    if (!grid || nums.length < 2) return null;

    sec.classList.add('re-flow-ready');

    /* Einzeilig? (Nummern etwa auf gleicher Hoehe) -> Verbindungslinie moeglich.
       Mehrzeilig (z.B. 2x2) ODER Nummern auf den Bildern -> nur Glow, KEINE
       Linie (wuerde durch die Bilder laufen). */
    var y0 = nums[0].getBoundingClientRect().top;
    var singleRow = nums.every(function (n) {
      return Math.abs(n.getBoundingClientRect().top - y0) < 28;
    });
    var drawLine = singleRow && !opts.glowOnly;

    var track = null, dot = null, startX = 0, endX = 0, flowTl = null;

    if (drawLine) {
      grid.classList.add('re-flow-host');
      track = document.createElement('span');
      track.className = 're-flow-track';
      dot = document.createElement('span');
      dot.className = 're-flow-dot';
      var leaf = document.createElement('span');
      leaf.className = 're-flow-leaf';
      leaf.setAttribute('aria-hidden', 'true');
      leaf.innerHTML = LEAF_SVG;
      dot.appendChild(leaf);
      grid.appendChild(track);
      grid.appendChild(dot);
    }

    function layout() {
      if (!drawLine) return;
      var gr = grid.getBoundingClientRect();
      var f = nums[0].getBoundingClientRect();
      var l = nums[nums.length - 1].getBoundingClientRect();
      startX = (f.left + f.right) / 2 - gr.left;
      endX = (l.left + l.right) / 2 - gr.left;
      var y = (f.top + f.bottom) / 2 - gr.top;
      track.style.left = startX + 'px';
      track.style.top = y + 'px';
      track.style.width = endX - startX + 'px';
      dot.style.top = y + 'px';
      dot.style.left = startX + 'px';
    }
    layout();

    function litOn(n) { n.classList.add('is-lit'); }
    function litOff(n) { n.classList.remove('is-lit'); }

    function startFlow() {
      if (flowTl) flowTl.kill();
      var travel = drawLine ? 3.0 : 2.2;
      flowTl = gsap.timeline({ repeat: -1, repeatDelay: drawLine ? 0.4 : 2.6 });
      if (drawLine) {
        flowTl.set(dot, { left: startX + 'px', x: 0, opacity: 0 });
        flowTl.to(dot, { opacity: 1, duration: 0.3 }, 0);
        flowTl.to(dot, { x: endX - startX, duration: travel, ease: 'none' }, 0);
        flowTl.to(dot, { opacity: 0, duration: 0.35 }, travel - 0.05);
      }
      nums.forEach(function (n, i) {
        var t = travel * (i / (nums.length - 1));
        flowTl.call(litOn, [n], t);
        flowTl.call(litOff, [n], Math.min(t + 0.7, travel + 0.5));
      });
    }

    var st = ScrollTrigger.create({
      trigger: sec,
      start: 'top 74%',
      once: true,
      onEnter: function () {
        sec.classList.add('is-drawn');
        layout();
        if (drawLine) {
          gsap.fromTo(
            track,
            { scaleX: 0 },
            { scaleX: 1, duration: 0.8, ease: 'power2.inOut', onComplete: startFlow }
          );
        } else {
          startFlow();
        }
        gsap.from(nums, {
          scale: 0.5,
          opacity: 0,
          duration: 0.5,
          ease: 'back.out(1.8)',
          stagger: 0.1,
          clearProps: 'transform,opacity'
        });
      }
    });

    var rT;
    function onResize() {
      clearTimeout(rT);
      rT = setTimeout(layout, 150);
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('load', layout);

    return function cleanup() {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', layout);
      if (flowTl) flowTl.kill();
      if (st) st.kill();
      if (track && track.parentNode) track.remove();
      if (dot && dot.parentNode) dot.remove();
      nums.forEach(litOff);
      sec.classList.remove('is-drawn');
    };
  }

  function init() {
    if (reduce) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
      return;

    gsap.registerPlugin(ScrollTrigger);

    var body = document.body;
    var isHome = body.classList.contains('template-index');
    var isProduct = body.classList.contains('template-product');

    /* --- 1) Globale Scroll-Reveals ---------------------------------------- */
    var groups = [
      '.re-proz__head, .re-zub__head, .re-vgl__head, .re-tstm__head, .rekc-head',
      '.re-proz__card',
      '.re-zub__card',
      '.re-vgl__row',
      '.re-tstm__card',
      '.rekc-item'
    ];
    if (isHome) groups.push('.product-card');
    if (isProduct) {
      groups.push(
        '.re-usp__row',
        '.re-refrow',
        '.sh-advantage',
        '.re-infobox',
        '.product-description-full'
      );
    }

    groups.forEach(function (sel) {
      var els = gsap.utils.toArray(sel);
      if (!els.length) return;
      var isCards = sel === '.re-tstm__card';
      gsap.set(els, { opacity: 0, y: isCards ? 40 : 32, scale: 0.98 });
      ScrollTrigger.batch(els, {
        start: 'top 88%',
        once: true,
        onEnter: function (batch) {
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: isCards ? 0.85 : 0.8,
            ease: 'power3.out',
            stagger: 0.09,
            overwrite: true,
            clearProps: 'transform'
          });
        }
      });
    });

    /* --- 2) Vergleich: Haekchen ZEICHNEN + poppen, Testsieger + VS rein ---- */
    gsap.utils.toArray('.re-vgl__rows').forEach(function (list) {
      var oks = list.querySelectorAll('.re-vgl__ic--ok');
      var okPaths = list.querySelectorAll('.re-vgl__ic--ok path');
      okPaths.forEach(function (p) {
        try {
          var L = p.getTotalLength();
          p.style.strokeDasharray = L;
          p.style.strokeDashoffset = L;
        } catch (e) {}
      });
      if (oks.length) gsap.set(oks, { scale: 0.4, transformOrigin: '50% 50%' });
      ScrollTrigger.create({
        trigger: list,
        start: 'top 82%',
        once: true,
        onEnter: function () {
          if (oks.length)
            gsap.to(oks, {
              scale: 1,
              duration: 0.55,
              ease: 'back.out(2.4)',
              stagger: 0.07,
              clearProps: 'transform'
            });
          okPaths.forEach(function (p, i) {
            gsap.to(p, {
              strokeDashoffset: 0,
              duration: 0.5,
              ease: 'power2.out',
              delay: 0.12 + i * 0.07,
              clearProps: 'strokeDashoffset,strokeDasharray'
            });
          });
        }
      });
    });

    gsap.utils.toArray('.re-vgl').forEach(function (sec) {
      var win = sec.querySelector('.re-vgl__winner');
      var vs = sec.querySelector('.re-vgl__vsbadge');
      var us = sec.querySelector('.re-vgl__col--us');
      if (win) gsap.set(win, { scale: 0, transformOrigin: '50% 100%' });
      if (vs) gsap.set(vs, { scale: 0, transformOrigin: '50% 50%' });
      ScrollTrigger.create({
        trigger: sec.querySelector('.re-vgl__vs') || sec,
        start: 'top 80%',
        once: true,
        onEnter: function () {
          if (win)
            gsap.to(win, {
              scale: 1,
              duration: 0.6,
              ease: 'back.out(2.6)',
              delay: 0.15,
              clearProps: 'transform'
            });
          if (vs)
            gsap.to(vs, {
              scale: 1,
              duration: 0.5,
              ease: 'back.out(3)',
              delay: 0.05,
              clearProps: 'transform'
            });
          if (us) us.classList.add('re-vgl__col--won');
        }
      });
    });

    /* --- 3) Nummern-Fluss: Prozess-Timeline (Home + PDP) + Zubereitung -----
       Nur Desktop; Mobile-Raster bleibt unangetastet.
       - .re-proz  (Home 5er = Timeline, PDP 4er = "Echter Matcha"): einzeilig,
         Nummern ueber den Bildern -> verbindende Linie + wandernder Puls.
       - .re-zub   (PDP "Matcha richtig zubereiten", 2x2, Nummern AUF den
         Bildern): nur sequenzielles Nummern-Glow (Linie wuerde durch die
         Bilder laufen -> bewusst keine Linie). */
    var mm = gsap.matchMedia();
    mm.add('(min-width: 990px)', function () {
      var cleanups = [];
      gsap.utils.toArray('.re-proz').forEach(function (sec) {
        var c = buildStepFlow(sec, {
          numSel: '.re-proz__num',
          gridSel: '.re-proz__grid'
        });
        if (c) cleanups.push(c);
      });
      gsap.utils.toArray('.re-zub').forEach(function (sec) {
        var c = buildStepFlow(sec, {
          numSel: '.re-zub__num',
          gridSel: '.re-zub__grid',
          glowOnly: true
        });
        if (c) cleanups.push(c);
      });
      return function () {
        cleanups.forEach(function (fn) { fn(); });
      };
    });

    /* --- 4) Hero: 2. Ring + mehr Dampf ------------------------------------ */
    (function heroDeco() {
      var circle = document.querySelector('.rehero-circle');
      if (circle && !circle.querySelector('.re-hero-ring2')) {
        var ring2 = document.createElement('span');
        ring2.className = 're-hero-ring2';
        ring2.setAttribute('aria-hidden', 'true');
        circle.appendChild(ring2);
      }
      var steam = document.querySelector('.rehero-steam');
      if (steam && !steam.querySelector('.re-steam-x')) {
        var extra = [
          { l: '36%', d: '0s', dur: '8.5s', s: 11 },
          { l: '52%', d: '3s', dur: '9.5s', s: 13 },
          { l: '44%', d: '5.5s', dur: '7.8s', s: 10 }
        ];
        extra.forEach(function (p) {
          var i = document.createElement('i');
          i.className = 're-steam-x';
          i.style.left = p.l;
          i.style.animationDelay = p.d;
          i.style.animationDuration = p.dur;
          i.style.width = p.s + 'px';
          i.style.height = p.s + 'px';
          steam.appendChild(i);
        });
      }
    })();

    /* --- 5) Hero: Bewertungszahl sanft hochzaehlen (einmalig) ------------- */
    var scoreEl = document.querySelector('.rehero-score');
    if (scoreEl) {
      var raw = (scoreEl.textContent || '').trim();
      var target = parseFloat(raw.replace(',', '.'));
      if (!isNaN(target) && target > 0) {
        var decimals = (raw.split(/[.,]/)[1] || '').length;
        var fmt = function (v) {
          return decimals
            ? v.toFixed(decimals).replace('.', ',')
            : String(Math.round(v));
        };
        var counter = { v: 0 };
        scoreEl.textContent = fmt(0);
        gsap.to(counter, {
          v: target,
          duration: 1.2,
          ease: 'power2.out',
          delay: 0.3,
          onUpdate: function () { scoreEl.textContent = fmt(counter.v); },
          onComplete: function () { scoreEl.textContent = raw; }
        });
      }
    }

    /* --- 6) Testimonials: Sterne funkeln sequenziell beim Reveal --------- */
    gsap.utils.toArray('.re-tstm__stars').forEach(function (row) {
      var stars = gsap.utils.toArray(row.querySelectorAll('.re-tstm__star.is-full'));
      if (!stars.length) return;
      gsap.set(stars, { scale: 0.5, transformOrigin: '50% 50%' });
      ScrollTrigger.create({
        trigger: row,
        start: 'top 90%',
        once: true,
        onEnter: function () {
          stars.forEach(function (s, i) {
            gsap.to(s, {
              scale: 1,
              duration: 0.5,
              ease: 'back.out(3)',
              delay: i * 0.12,
              clearProps: 'transform'
            });
            setTimeout(function () {
              s.classList.add('re-spark');
              setTimeout(function () { s.classList.remove('re-spark'); }, 760);
            }, i * 120 + 60);
          });
        }
      });
    });

    /* --- 7) Durchgestrichene Preise: Rabatt-Linie + Preis-Pop ------------- */
    function revealPriceStrike(scope, cmpSel, priceSel, badgeSel) {
      gsap.utils.toArray(scope).forEach(function (el) {
        var cmp = el.querySelector(cmpSel);
        if (!cmp) return; // kein Vergleichspreis -> nichts tun
        ScrollTrigger.create({
          trigger: el,
          start: 'top 92%',
          once: true,
          onEnter: function () {
            cmp.classList.add(cmpSel.indexOf('compare-at-price') > -1
              ? 're-cmp-strike' : 're-strike-on');
            var price = priceSel ? el.querySelector(priceSel) : null;
            if (price) {
              price.classList.add('re-price-pop');
              setTimeout(function () { price.classList.remove('re-price-pop'); }, 700);
            }
            var badge = badgeSel ? el.querySelector(badgeSel) : null;
            if (badge) {
              badge.classList.add('re-badge-pop');
              setTimeout(function () { badge.classList.remove('re-badge-pop'); }, 650);
            }
          }
        });
      });
    }

    if (isHome) {
      revealPriceStrike(
        '.product-card',
        's.product-card__price-compare',
        '.product-card__price--sale',
        '.product-card__save-badge'
      );
    }
    if (isProduct) {
      revealPriceStrike(
        '.product-info__price',
        'compare-at-price',
        'sale-price',
        null
      );
    }

    /* --- 8) Produktseite: Produktbilder + ATC-Glanz ---------------------- */
    if (isProduct) {
      var gmedia = gsap.utils.toArray(
        '.product-gallery--desktop-grid .product-gallery__media:not(:first-child)'
      );
      if (gmedia.length) {
        gsap.set(gmedia, { opacity: 0 });
        ScrollTrigger.batch(gmedia, {
          start: 'top 90%',
          once: true,
          onEnter: function (b) {
            gsap.to(b, { opacity: 1, duration: 0.6, ease: 'power2.out', stagger: 0.08 });
          }
        });
      }
      var thumbs = document.querySelector('.product-gallery__thumbnail-list-wrapper');
      if (thumbs) {
        gsap.set(thumbs, { opacity: 0, y: 16 });
        ScrollTrigger.create({
          trigger: thumbs,
          start: 'top 96%',
          once: true,
          onEnter: function () {
            gsap.to(thumbs, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: 'power3.out',
              clearProps: 'transform'
            });
          }
        });
      }
      var atc = document.querySelector(
        '[data-block-type="buy-buttons"] button[type="submit"]'
      );
      if (atc) {
        ScrollTrigger.create({
          trigger: atc,
          start: 'top 96%',
          once: true,
          onEnter: function () { atc.classList.add('re-atc-glint'); }
        });
      }
    }

    ScrollTrigger.refresh();
  }

  function boot() {
    heroRotator();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () {
    if (!reduce && typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  });
})();
